import React from 'react'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { FEATURE_UC_IN_WEBREGISTER_INPUT_ERROR } from '../../../../../constants'
import { LineItemQuantityErrorProps } from './useLineItemQuantityErrorModel'
import { LineItemQuantityError as LineItemQuantityErrorUnified } from './LineItemQuantityError'
import { LineItemQuantityErrorLegacy } from './LineItemQuantityErrorLegacy'

export const LineItemQuantityError: React.FC<LineItemQuantityErrorProps> = props => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_INPUT_ERROR
  )

  return isUnifiedEnabled ? (
    <LineItemQuantityErrorUnified {...props} />
  ) : (
    <LineItemQuantityErrorLegacy {...props} />
  )
}
